import { CvcBox } from '@apply/components';
import { usePaymentStore } from '../../../../../state/paymentStore';
import { CardFocusType } from '../../../constants/CardFocusType';

interface CardCvcParameters {
    disabled: boolean;
}
export const CardCvc: React.FC<CardCvcParameters> = ({ disabled }) => {
    const cvc = usePaymentStore((s) => s.cvc);
    const set_cvc = usePaymentStore((s) => s.set_cvc);
    const set_cardFocus = usePaymentStore((s) => s.set_cardFocus);

    return (
        <CvcBox
            name='cvc'
            label='CVC'
            value={cvc}
            onChange={(value) => set_cvc(value)}
            onFocusIn={() => set_cardFocus(CardFocusType.CVC)}
            disabled={disabled}
        />
    );
};
